/**
 * Ozera “Add to bag” on carousel cards: ensure variant id is not left disabled.
 * Do not use capture-phase stopPropagation on document — it runs before the event
 * reaches the button and blocks clicks entirely. Swiper is handled via
 * .swiper-no-swiping on bag wrappers in product-item.liquid.
 */
(function () {
  function enableOzeraVariantInputs() {
    document
      .querySelectorAll(
        '.product-item--ozera-bag form[data-type="add-to-cart-form"] input[name="id"]'
      )
      .forEach(function (input) {
        input.removeAttribute("disabled");
      });
  }

  document.addEventListener("DOMContentLoaded", enableOzeraVariantInputs);
  document.addEventListener("shopify:section:load", enableOzeraVariantInputs);
})();
